module.exports = __webpack_public_path__ + "static/media/b10.26c32881.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/butterfly/b10.jpg
// module id = 456
// module chunks = 0